import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import LyricCard from './LyricCard';

function LyricFeed() {
  const [lyrics, setLyrics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const ITEMS_PER_PAGE = 10;

  const fetchLyrics = async (pageNumber = 0, append = false) => {
    try {
      setLoading(true);
      setError(null);

      const from = pageNumber * ITEMS_PER_PAGE;
      const to = from + ITEMS_PER_PAGE - 1;

      const { data, error } = await supabase
        .from('lyrics')
        .select(`
          id,
          content,
          likes_count,
          created_at,
          user_id,
          track_id,
          users (
            id,
            username,
            full_name,
            avatar_url
          ),
          tracks (
            id,
            title,
            artist,
            album,
            cover_image
          )
        `)
        .order('created_at', { ascending: false })
        .range(from, to);

      if (error) throw error;

      if (!data || data.length < ITEMS_PER_PAGE) {
        setHasMore(false);
      }

      if (append) {
        setLyrics(prev => [...prev, ...data]);
      } else {
        setLyrics(data);
      }

    } catch (err) {
      console.error('Error cargando lyrics:', err);
      setError('Error al cargar los lyrics. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLyrics(0, false);
  }, []);

  const loadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchLyrics(nextPage, true);
  };

  const refreshFeed = () => {
    setPage(0);
    setHasMore(true);
    fetchLyrics(0, false);
  };

  if (error) {
    return (
      <div style={styles.error}>
        <p>{error}</p>
        <button onClick={refreshFeed} style={styles.retryButton}>
          Reintentar
        </button>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {lyrics.length === 0 && !loading ? (
        <div style={styles.empty}>
          <p>No hay lyrics todavía. ¡Sé el primero en publicar!</p>
        </div>
      ) : (
        <div style={styles.feedList}>
          {lyrics.map((lyric) => (
            <LyricCard 
              key={lyric.id} 
              lyric={lyric}
              onUpdate={refreshFeed}
            />
          ))}
        </div>
      )}

      {loading && (
        <div style={styles.loading}>
          <div style={styles.spinner}></div>
          <p>Cargando...</p>
        </div>
      )}

      {!loading && hasMore && lyrics.length > 0 && (
        <button onClick={loadMore} style={styles.loadMoreButton}>
          Ver más
        </button>
      )}

      {!hasMore && lyrics.length > 0 && (
        <p style={styles.endMessage}>
          Has visto todos los lyrics disponibles
        </p>
      )}
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '20px',
  },
  feedList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #2563eb',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadMoreButton: {
    width: '100%',
    padding: '15px',
    marginTop: '20px',
    backgroundColor: '#2563eb',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  endMessage: {
    textAlign: 'center',
    color: '#888',
    padding: '20px',
    fontSize: '14px',
  },
  error: {
    textAlign: 'center',
    padding: '40px',
    color: '#d32f2f',
  },
  retryButton: {
    marginTop: '15px',
    padding: '10px 20px',
    backgroundColor: '#2563eb',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  empty: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#666',
    fontSize: '16px',
  },
};

export default LyricFeed;